import moment from "moment";

import {
    type IPrintInfoAPIData,
    PrintInfoAPI,
} from "commonComponents/print/PrintInfo/PrintInfo.types";

import { type PrintHeader } from "handlers";

export interface IPrintHeaderAPIData {
    logo?: string | null;
    builderInfo: IPrintInfoAPIData;
    builderTime?: string | null;
}

/** Used to display the print page headers */
export class PrintHeaderAPI {
    constructor(data: IPrintHeaderAPIData | PrintHeader) {
        this.builderInfo = new PrintInfoAPI(data.builderInfo!);
        this.builderTime = data.builderTime ? moment(data.builderTime) : undefined;
        this.logo = data.logo ?? "";
    }

    builderInfo: PrintInfoAPI;
    builderTime: moment.Moment | undefined;
    logo: string;
}
